import { Button } from "reactstrap";
import FormModal from "./FormModal";

const ConfirmDeleteModal = ({ title, isOpen, toggle, handleDelete }) => {
  return (
    <FormModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      backdrop={true}
      headerToggle={false}
      footerButtons={
        <>
          <Button color="primary" type="button" onClick={toggle}>
            Batal
          </Button>
          <Button
            type="button"
            color="danger"
            onClick={() => {
              handleDelete().then(toggle);
            }}
          >
            Yes
          </Button>
        </>
      }
    />
  );
};

export default ConfirmDeleteModal;
